import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class StepperService {
	private navigateToNextStep$ = new Subject<boolean>();
	private navigateToStepIndex$ = new Subject<number>();

	get allowNavigateToNextStep$() {
		return this.navigateToNextStep$.asObservable();
	}

	get navigateToStepByIndex$() {
		return this.navigateToStepIndex$.asObservable();
	}

	navigate(goToNextStep?: boolean) {
		this.navigateToNextStep$.next(!!goToNextStep);
	}

	navigateToSelectedStep(stepIndex: number) {
		this.navigateToStepIndex$.next(stepIndex);
	}
}
